import "firebase/analytics"
import "firebase/remote-config"

import * as firebase from "firebase/app"
import Config from "react-native-config"

const {
  API_KEY,
  AUTH_DOMAIN,
  DATABASE_URL,
  PROJECT_ID,
  STORAGE_BUCKET,
  MESSAGING_SENDER_ID,
  APP_ID,
  MEASUREMENT_ID,
} = Config

const firebaseConfig = {
  apiKey: API_KEY,
  authDomain: AUTH_DOMAIN,
  databaseURL: DATABASE_URL,
  projectId: PROJECT_ID,
  storageBucket: STORAGE_BUCKET,
  messagingSenderId: MESSAGING_SENDER_ID,
  appId: APP_ID,
  measurementId: MEASUREMENT_ID,
}

let app = firebase.initializeApp(firebaseConfig)
let remoteConfig = app.remoteConfig()

async function init() {
  remoteConfig.defaultConfig = {
    auth0_domain: "tap-test.eu.auth0.com",
    auth0_clientId: "T60M78zWmbkoyEdys2fweASXUrv9mEEs",
    auth0_scope: "offline_access openid profile email",
    auth0_audience: "https://api-development.tapandcollect-nonprod.co.uk/",
    auth0_redirect_uri: "http://localhost:19006",
  }

  await remoteConfig.fetch()
  await remoteConfig.activate()
  return true
}

async function registerForPush() {
  return null
}

function logEvent(name, args) {
  // TODO - fix this on web
  // app.analytics.logEvent(name, args);
}

function getConfigValue(key) {
  const value = remoteConfig.getValue(key)._value
  return value || ""
}

async function getPushToken() {
  return null
}

async function deletePushToken() {
  return null
}

export default {
  init,
  registerForPush,
  logEvent,
  getConfigValue,
  getPushToken,
  deletePushToken,
}
